export const SHOW_CLASSES_UPTO_NUMBER_OF = 3;

export const FIRST_PAGE = 1;

export const ITEMS_COUNT_PER_PAGE = 50;

export const DEFAULT_PAGINATION = {
  activePage: FIRST_PAGE,
  itemsCountPerPage: ITEMS_COUNT_PER_PAGE,
  totalItemsCount: 0,
}


const locale = {
  id: 'StudentConstant',
  code: 'CN',
  text: {
    "./images/student_en@2x.png": "./images/student@2x.png",
    'Student Record Documentation and Management': '学员档案记录与管理',
    'Student Management includes entry, search, edit multiple students, and register students through iPad. Student Management divides all students into different categories: current, not enrolled, enrolled, and past students. It allows you to enroll students, as well as payments and attendance. It also allows you to check student status.': '学员管理包括录入，查询，及批量学员同时操作，并可以设置前台iPad登记与报名。学员被划分为当期，未排班，在读，以及历史的多种状态类型。通过简单的操作给学生排班，充值，缴费，办理签到等各种事项。随时可以查询学生的上课状态，缴费，学费，退费，充值等记录。',
  }
}

export const onBoardingContents = {
  // we show this when student state is 'all_not_archived'
  all_not_archived: {
    title: __('Student Record Documentation and Management', locale),
    text: __('Student Management includes entry, search, edit multiple students, and register students through iPad. Student Management divides all students into different categories: current, not enrolled, enrolled, and past students. It allows you to enroll students, as well as payments and attendance. It also allows you to check student status.', locale),
    image: require(__('./images/student_en@2x.png', locale)),
    showArrow: true,
  }

}



// WEBPACK FOOTER //
// ./src/containers/pages/Student/constants.js